{
  "endTime": "结束时间",
  "startTime": "开始时间",
  "time": "时间"
}
